<script>
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'
  import ItemForm from '../../components/ItemForm/index.svelte'

  // `item` carries any server-seeded defaults — e.g. when adding from inside a
  // container, it preselects that container plus its property and space.
  let { item = {}, property, spaces, containers, properties } = $props()
</script>

<svelte:head>
  <title>Add New Item | Maset</title>
</svelte:head>

<ApplicationLayout>
  <ItemForm {item} {property} {spaces} {containers} {properties} />
</ApplicationLayout> 